export default {
  methods: {
    inputFocus() {
      if (!this.disabled) this.$refs.input.focus();
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/form/inputFocusMixins.js